import * as React from "react";
import * as i18next from "i18next"; // traduction
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { onUpdateUser, onRemouveUser /*, item*/ } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean ( token )
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorizationadd: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSUPDATED,
  ]);
  const authorizationremove: any = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.ADMINISTRATIONUSERSDELECTED,
  ]);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <div className="actionUserUser">
      {authorizationadd && (
        <div
          className="actionUserText"
          style={{ cursor: "pointer", textAlign: "left" }}
          onClick={onUpdateUser}
        >
          {" "}
          {i18next.t("modifier")}
        </div>
      )}
      {authorizationremove && (
        <div
          className="actionUserText"
          style={{ cursor: "pointer", textAlign: "left" }}
          onClick={onRemouveUser}
        >
          {" "}
          {i18next.t("supprimer")}
        </div>
      )}
    </div>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  onUpdateUser?: any;
  onRemouveUser?: any;
  item?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@widgets/users/actions/component.tsx